import react, { useState, createContext, useEffect } from 'react';
export const ContextHotel = createContext({ hotelContext: '', onClickId: () => { }});

export const HotelProvider = ({ children }) => {
    const [hotelContext, setHotelContext] = useState(null);
    const HandleClickId=(id)=>{
        setHotelContext(id);
    }
    
    return <ContextHotel.Provider value={{ hotelContext: hotelContext, onClickId: HandleClickId }}>{children}</ContextHotel.Provider>;
}